import { Component, inject, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CheckListItem } from '../model/checkList-item';

@Component({
    selector: 'app-checklist-dialog',
    templateUrl: './checklist-dialog.component.html',
    styleUrl: './checklist-dialog.component.css',
    standalone: false
})
export class ChecklistDialogComponent {

  data = inject(MAT_DIALOG_DATA);
  // checked = false;

  list: CheckListItem[] = [];

  title = '';

  constructor(
    public dialogRef: MatDialogRef<ChecklistDialogComponent>
  ) { }

  ngOnInit(): void {

    // console.log('zoznam: ' + JSON.stringify(this.dataMatDialog.data));
    // console.log('zoznam2: ' + JSON.stringify(this.data));

    // this.zoznam = this.dataMatDialog.data;

    this.title = this.data.title;
    const checknuteDataKodyList: string[] = this.data.vybraneDataKodyList;

    this.data.dataZoznam.forEach(item => {
      let checkListItem = new CheckListItem();
      const kodAPopis: string[] = item.split('~');
      checkListItem.kod = kodAPopis[0];
      checkListItem.popis = kodAPopis[1];

      if (checknuteDataKodyList && checknuteDataKodyList.includes(checkListItem.kod)) {
        checkListItem.vybrany = true;
      }

      this.list.push(checkListItem);
    });

    // console.log('list: ' + JSON.stringify(this.list));

  }

  selectAll() {
    this.data.stupneStudiaZoznam.forEach(sp => {
      // sp.zaradeny = this.checked ? true : false;
    });
  }

  checkboxClick($event) {
    $event.stopPropagation();
  }

  onConfirm(): void {

    let oznaceneItemyList = this.list.filter(item => item.vybrany).map(item => item.kod);

    if (oznaceneItemyList) {
      this.dialogRef.close(oznaceneItemyList);
    }
  }

}
